import React from "react";
import "./header.css";

const Header: React.FC = () => {
  return (
    <header className="header">
      <h1 className="header-title">Spring-Helper</h1>
    </header>
  );
};

export default Header;
